import React from 'react';
import './FeaturesSection.scss';
import { usePlans } from 'hooks/plan';
import { Plan } from 'models/Plan'
// Import icons from react-icons
import { FaSearch, FaKey, FaStore, FaChartLine, FaRocket, FaGem, FaCalculator, FaTrophy } from "react-icons/fa";
const FeaturesSection: React.FC = () => {

  const { plans } = usePlans()
  // Find the lifetime plan dynamically
  const lifetimePlan = plans?.find?.((plan: Plan) => plan?.interval === "lifetime");
  if (!lifetimePlan) return null;

  // Monthly quota-based features
  const monthlyFeatures = [
    { name: "Listing Searches", quota: lifetimePlan.listingSearches, icon: <FaSearch className="text-primary text-lg" /> },
    { name: "Keyword Searches", quota: lifetimePlan.keywordsSearches, icon: <FaKey className="text-primary text-lg" /> },
    { name: "Store Searches", quota: lifetimePlan.storeSearches, icon: <FaStore className="text-primary text-lg" /> },
    { name: "Marketing Searches", quota: lifetimePlan.marketSearches, icon: <FaChartLine className="text-primary text-lg" /> },
  ];

  // Unlimited seller tools
  const unlimitedFeatures = [
    { name: "Product Discovery", icon: <FaRocket className="text-primary text-lg" /> },
    { name: "Store Discovery", icon: <FaGem className="text-primary text-lg" /> },
    { name: "Daraz Profit Calculator", icon: <FaCalculator className="text-primary text-lg" /> },
    { name: "Product Rank Finder", icon: <FaTrophy className="text-primary text-lg" /> },
  ];

  return (
    <section className="features-section">
      <div className="container">
        <h2 className="section-title">What You Get: Ultimate Lifetime Plan Tools</h2>
        <p className="section-subtitle">A powerful suite of tools with monthly-resetting quotas and unlimited access to key features.</p>
        
        <div className="features-grid">
          
          {/* Column 1: Monthly Quotas */}
          <div className="features-column monthly-column">
            <h3>Extension Tools (Monthly Quota Reset)</h3>
            <ul className="feature-list">
              {monthlyFeatures.map((feature) => (
                <li key={feature.name}>
                  <span className="feature-icon">{feature.icon}</span>
                  <div className="feature-details">
                    <p className="feature-name">{feature.name}</p>
                    <p className="feature-quota">{feature.quota} Searches/Month</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 2: Unlimited Features */}
          <div className="features-column unlimited-column">
            <h3>Unlimited Access Features</h3>
            <ul className="feature-list">
              {unlimitedFeatures.map((feature) => (
                <li key={feature.name} className="unlimited-item">
                  <span className="feature-icon unlimited-icon"><FaGem /></span>
                  <div className="feature-details">
                    <p className="feature-name">{feature.name}</p>
                    <p className="feature-quota">Truly Unlimited Usage</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        <a href="/user/billing" className="cta-button features-cta">
            Get The Ultimate Lifetime Toolkit
        </a>
      </div>
    </section>
  )
};

export default FeaturesSection;